var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayAsLink
    ? _c("div", [
        _c("a", { attrs: { href: `tel:${_vm.display}` } }, [
          _vm._v(_vm._s(_vm.display)),
        ]),
      ])
    : _c("div", [_vm._v("\n  " + _vm._s(_vm.display) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }